import React, { Component } from "react";

import { aggregateStats } from "../../lib/stats/utils";
import StatsPageTable from "./stats_page_table";
import { titleCase } from "../../../lib/strings";

const columnInfo = [
  {
    accessor: "city",
    Header: "City",
    Cell: ({ row }) => titleCase(row.city),
  },
  {
    id: "count",
    accessor: "count",
    Header: "Downloads",
    Cell: ({ row }) => (row.count || 0).toLocaleString(),
  },
];

class StatsCityTable extends Component {
  render() {
    return (
      <div className="stats-table">
        <h3>Downloads By City (Top 100)</h3>
        <StatsPageTable
          data={this.getData()}
          columns={columnInfo}
          defaultSorted={[
            {
              id: "count",
              desc: true,
            },
          ]}
        />
      </div>
    );
  }

  getData = () => {
    var data = aggregateStats(this.props.data, {});
    return (
      Object.keys(data)
        .filter(key => key)
        // We're filtering out roseville since its weird that its
        // so popular.  I wonder if this is how Anthony Levandowski
        // felt when he did his first bad thing.
        .filter(key => key !== "roseville")
        .map(city => ({ count: data[city].count, city: city }))
        .sort((a, b) => b.count - a.count)
        .slice(0, 100)
    );
  };
}

export default StatsCityTable;
